"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIframe = void 0;
var _react = require("react");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Iframe = require("./partials/Iframe");
var _TaskManager = require("../TaskManager.provider");
var _useItem = require("./useItem");
var _Iframe2 = _interopRequireDefault(require("./partials/Iframe/Iframe.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useIframe = (itemID, itemLanguage, taskID, kotarParams, minDate, maxDate) => {
  const {
    task
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    getLOItem
  } = (0, _useItem.useItem)(itemID, itemLanguage, undefined, undefined, taskID, kotarParams, minDate, maxDate, false, false);
  const iframeRef = (0, _react.useRef)(null); //todo: fix type
  const styles = (0, _Iframe2.default)();
  const setIframeData = (0, _react.useCallback)(iframeData => {
    if (iframeRef.current) {
      try {
        iframeRef.current.remove();
      } catch (ex) {}
    }
    if (iframeData) {
      let iframe = document.createElement('div');
      iframe.className = styles['cc-TaskManager__iframe'];
      iframeRef.current = iframe;
      window.document.body.appendChild(iframeRef?.current);
      const innerComp = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Iframe.Iframe, {
        iframeData: iframeData,
        onClose: () => {
          setIframeData(undefined);
        }
      });
      _reactDom.default.render(innerComp, iframeRef.current);
    }
  }, [styles]);
  (0, _react.useEffect)(() => {
    return () => {
      if (iframeRef.current) {
        try {
          iframeRef.current.remove();
        } catch (ex) {}
      }
    };
  }, []);
  (0, _react.useEffect)(() => {
    const onmessage = event => {
      //todo: fix type
      try {
        var msg = event.data;
        var args = msg.split('|');
        if (args[0] === 'mybag') {
          if (args[1] === 'itemSelected') {
            var itemID = args[2];
            var cetLanguage = args[3];
            getLOItem(itemID, cetLanguage);
            setIframeData(undefined);
          } else if (args[1] === 'colorboxClose') {
            // TODO: studio now sends studio|editEnded. maybe this block is not used any more
            setIframeData(undefined);
          } else if (args[1] === 'startStudioOnCopy') {
            //startStudioOnCopy();
          }
        } else if (args[0] === 'studio') {
          if (args[1] === 'editEnded') {
            if (task?.item && task.item.id && task.item.cetLanguage) {
              getLOItem(task.item.id, task.item.cetLanguage, true, task);
            }
            setIframeData(undefined);
          }
        }
      } catch (e) {}
    };
    window.addEventListener('message', onmessage, false);
    return () => {
      window.removeEventListener('message', onmessage);
    };
  }, [getLOItem, setIframeData, task]);
  return {
    setIframeData
  };
};
exports.useIframe = useIframe;